import { z } from "zod";
import { CONVERGENCE_STRATEGY_VALUES } from "../../constants/convergence-strategy.js";
import { NODE_TITLE_MAX_LENGTH } from "../../constants/limits.js";
import { DecisionSchema } from "./decision.js";
export const NodeSchema = z
    .object({
    id: z.uuid(),
    title: z.string().min(1).max(NODE_TITLE_MAX_LENGTH),
    orderIndex: z.number().int().nonnegative(),
    convergenceStrategy: z.enum(CONVERGENCE_STRATEGY_VALUES).nullable(),
    decision: DecisionSchema.nullable(),
    nextNodeId: z.uuid().nullable(),
    endingId: z.uuid().nullable(),
})
    .refine((node) => [node.decision, node.nextNodeId, node.endingId].filter((outcome) => outcome !== null).length <= 1, "Issue exclusive : décision, transition directe ou fin — un nœud sans issue est terminal, résolu par les règles de fins");
